var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "#F6F6F6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44934 8.92348C4.23294 8.92348 4.01654 8.84105 3.85167 8.67617L1.00415 5.82865C0.674399 5.4989 0.674399 4.96306 1.00415 4.63331C1.3339 4.30356 1.86974 4.30356 2.19949 4.63331L4.44934 6.88316L10.4524 0.880124C10.7821 0.550375 11.318 0.550375 11.6477 0.880124C11.9775 1.20987 11.9775 1.74572 11.6477 2.07546L5.04701 8.67617C4.88213 8.84105 4.66574 8.92348 4.44934 8.92348Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2ac07cb3fab9433116aaf4fa93e15c29.svg";
export { ForwardRef as ReactComponent };